module.exports = __webpack_public_path__ + "static/media/Xero-First-Image.84c7110a.jpg";